module.exports = __webpack_public_path__ + "static/img/marker_end.6616edaf.png";